var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIncomeTransaction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    stroke: "#4AAE8C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7733 10.1635L19.7733 10.1635L19.775 10.1593C19.8926 9.87496 20.2693 9.80133 20.4887 10.0305L20.4894 10.0312L23.5015 13.1632C23.5016 13.1634 23.5017 13.1635 23.5018 13.1636C23.6566 13.3255 23.6693 13.5785 23.5324 13.7532C23.5321 13.7536 23.5318 13.754 23.5316 13.7543L15.1688 24.2157L15.8541 24.9318L26.6773 17.0351L26.6773 17.0351L26.6827 17.031C26.8522 16.9038 27.1004 16.9219 27.2572 17.0853C27.2573 17.0854 27.2574 17.0856 27.2575 17.0857L30.256 20.2307L30.256 20.2307L30.2568 20.2315C30.4762 20.4606 30.3863 20.8337 30.0971 20.9388L30.0928 20.9404L13.3724 27.1878C13.3722 27.1879 13.372 27.188 13.3717 27.1881C13.0045 27.3234 12.6556 26.959 12.807 26.598C12.807 26.5978 12.8071 26.5976 12.8072 26.5975L19.7733 10.1635Z",
    fill: "#4AAE8C",
    stroke: "#4AAE8C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncomeTransaction);
export default __webpack_public_path__ + "static/media/income-transaction.48d875b539849e787443b28814065810.svg";
export { ForwardRef as ReactComponent };